import React from "react";
import { connect } from "react-redux";
import { Column } from "devextreme-react/ui/data-grid";
import { Button, Popup, DataGrid, ValidationGroup } from "devextreme-react";
import validaciones from "../../../../../../../helpers/validaciones";
import {
  setDataNewComplain, nextStep,
  getDenunciaTrabajadorPendienteEmpresa, getWorkerData, setIdComplaint, doAutoCompleteTrabajadorInfo,
} from "../../actions";
import TextField from "../../../../../../Shared/fields/TextField";
import SelectField from "../../../../../../Shared/fields/SelectField";
import DateField from "../../../../../../Shared/fields/DateField";
const cancelButtonStyle = {
  paddingLeft: 30,
  paddingRight: 30,
};


class InfoDenuncia extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      openModalPendientes: false,
      alreadyExist: false,
      tipo: "",
      fechaDenuncia: "",
      openModalAlreadyExist: false,
    };
  }

  onFocusOutRut = () => {
    if (validaciones.validateRut(this.props.jsonData.formInfoDenuncia.rutTxt)) {
      this.props.dispatch(getWorkerData(
        false,
        this.props.jsonData,
        validaciones.formatRut(this.props.jsonData.formInfoDenuncia.rutTxt, { showDots: false, showHyphen: true }),
        this.props.dataTrabajador
      ));
    }
  }

  handleChange = (e) => {
    const jsonData = { ...this.props.jsonData };
    switch (e.element.id) {
      case "rutTxt": {
        let errorTxt = "";
        let isValidRut;
        if (validaciones.validateRut(e.value) === false) {
          errorTxt = "Formato de rut inválido";
          isValidRut = false;
          jsonData.formInfoDenuncia.rutTxt = "";
        } else {
          jsonData.formInfoDenuncia.rutTxt = validaciones.formatRut(e.value, { showDots: true, showHyphen: true });
          isValidRut = true;
        }
        e.component.option({
          validationError: { message: errorTxt },
          isValid: isValidRut,
        });
        break;
      }
      case "tipoDenuncia": {
        jsonData.formInfoDenuncia.tipoDenuncia = e.value;
        break;
      }
      default:
        jsonData.formInfoDenuncia[e.element.id] = e.value;
        break;
    }

    this.props.dispatch(setDataNewComplain(jsonData));
  }

  handleSave = () => {
    this.props.dispatch(nextStep());
  }

  openModalPendientes = (isDraft = null) => {
    this.setState({ openModalPendientes: true, isDraft });
  }

  handleCerrarPendientes = (isDraft = null) => {
    this.setState({ openModalPendientes: false, isDraft });
  }

  handleCloseModalExist = () => {
    this.setState({ openModalAlreadyExist: false });
  }

  handleOpenModalExist = () => {
    this.setState({ openModalAlreadyExist: true });
  }

  handleNextStep = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      const tipoDenuncia = this.props.jsonData.formInfoDenuncia.tipoDenuncia.DescripcionTipoDenuncia;
      const fechaDenuncia = this.props.jsonData.formInfoDenuncia.FechaPresentacion;
      const rutTrabajador = validaciones.formatRut(this.props.jsonData.formInfoDenuncia.rutTxt, { showDots: false, showHyphen: true });
      this.props.dispatch(getDenunciaTrabajadorPendienteEmpresa(
        this.openModalPendientes,
        this.props.jsonData,
        {
          CompanyRut: this.props.companyId,
          Rut: rutTrabajador,
          Tipo: tipoDenuncia,
          idTipoDenuncia: this.props.jsonData.formInfoDenuncia.tipoDenuncia.IdTipoDenuncia,
          Fecha: fechaDenuncia,
          userData: this.props.userData,
        }
      ));
    }
  }

  handleCompletar = async (data) => {
    const newJsonData = { ...this.props.jsonData };
    newJsonData.IdSiniestro = data.IdSiniestro;
    newJsonData.formInfoDenuncia.rutTxt = data.RutTrabajador;
    this.props.dispatch(setIdComplaint(data.IdSiniestro));
    await this.props.dispatch(doAutoCompleteTrabajadorInfo(newJsonData, this.props.companyId))
    this.handleCerrarPendientes();
  }

  renderDenunciasPendientes = (form) => (
    <div className="col-12" style={{ justifyContent: "center", height: "100%" }}>
      <div style={{ width: "100%", textAlign: "center", marginBottom: 20 }}>
        <p>
          Hemos identificado un siniestro tipo <span style={{ fontWeight: "bold", color: "#004A52" }}>{form.tipoDenuncia.DescripcionTipoDenuncia} </span>
          del rut <span style={{ fontWeight: "bold", color: "#004A52" }}>{form.rutTxt} </span>
          para la fecha <span style={{ fontWeight: "bold", color: "#004A52" }}>{new Date(form.FechaPresentacion).toLocaleDateString()} </span>.
          Puedes seleccionar la denuncia para enviarla o editarla.
          Recuerda que la última versión será considerada válida.
        </p>
      </div>

      <DataGrid
        dataSource={this.props.pendingComplaints}
        showBorders={false}
        showColumnLines={false}
        showRowLines
        height={140}
        className="simpleHeader"
        noDataText="Sin denuncias pendientes"
        hoverStateEnabled
      >
        <Column
          dataField="TipoDenuncia"
          cellRender={(props) => <div style={{ fontWeight: "bold", color: "#004A52" }}>{props.data.TipoDenuncia}</div>}
        />
        <Column dataField="FechaSiniestroOrPresentacion" dataType="date" caption="Fecha del siniestro" format="dd-MM-yyyy" />
        <Column dataField="IdSiniestro" caption="ID siniestro" />
        <Column
          cellRender={(props) => (
            <Button
              className="custom-button"
              text="Completar"
              onClick={() => this.handleCompletar(props.data)}
            />
          )}
        />
      </DataGrid>
      <div style={{ textAlign: "center", marginTop: 20 }} >
        <Button
          text="Cerrar"
          type="normal"
          className="custom-ouline-button"
          onClick={this.handleCerrarPendientes}
          style={{ ...cancelButtonStyle, marginRight: 15 }}
        />
      </div>
    </div>
  )

  render() {
    return (
      <ValidationGroup>
        <div className="row">
          <div className="col-12 newDenuncia-title" >
            <h2>Información de la denuncia</h2>
            <p> Completa los datos para pasar a la siguiente sección</p>
          </div>

          <div className="col-12">
            <h4 className="newDenuncia-subtitle">Datos de la denuncia</h4>

            <TextField
              label="Rut trabajador siniestrado"
              id="rutTxt"
              required
              value={this.props.jsonData.formInfoDenuncia.rutTxt}
              onChange={this.handleChange}
              onFocusOut={this.onFocusOutRut}
            />

            <SelectField
              id="tipoDenuncia"
              label="Selecciona el tipo de denuncia que quieres realizar"
              displayExpr="DescripcionTipoDenuncia"
              required
              dataSource={this.props.listaTipoDenuncias}
              onValueChanged={this.handleChange}
              value={this.props.jsonData.formInfoDenuncia.tipoDenuncia}
            />

            <DateField
              label={(this.props.jsonData.formInfoDenuncia &&
                this.props.jsonData.formInfoDenuncia.tipoDenuncia &&
                this.props.jsonData.formInfoDenuncia.tipoDenuncia.IdTipoDenuncia === "004") ?
                "Fecha de presentación" : "Fecha de siniestro"}
              id="FechaPresentacion"
              value={this.props.jsonData.formInfoDenuncia.FechaPresentacion}
              onChange={this.handleChange}
              type="date"

              required
            />

            <Button
              text="Siguiente"
              type="success"
              className="newDenuncia-next-button"
              onClick={this.handleNextStep}
              useSubmitBehavior
            />
          </div>

          <Popup
            visible={this.state.openModalPendientes}
            dragEnabled={false}
            maxHeight={370}
            onHiding={this.handleCerrarPendientes}
            maxWidth="600px"
            title="Denuncias"
            showTitle
            contentRender={() => {
              if (this.state.openModalPendientes) {
                return this.renderDenunciasPendientes(this.props.jsonData.formInfoDenuncia);
              }
            }}
          />
        </div>

      </ValidationGroup>
    );
  }
}
const mapStateToProps = (state) => ({
  jsonData: state.denuncias.jsonData,
  dataTrabajador: state.denuncias.dataTrabajador,
  companyId: state.global.companyId,
  userData: state.global.userData,
  listaDenuncias: state.denuncias.listaDenuncias,
  pendingComplaints: state.denuncias.pendingComplaints,
  disableContinueNewComplaint: state.denuncias.disableContinueNewComplaint,
  listaTipoDenuncias: state.global.listaTipoDenuncias,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoDenuncia);
